// checkbox-header.renderer.ts
import { Component, computed, inject, signal } from "@angular/core";
import { IHeaderAngularComp } from "ag-grid-angular";
import type { IHeaderParams } from "ag-grid-community";
import type {
  ColumnKey,
  EarnTableHeaderComponentParams,
} from "@bitwarden/web-vault/app/models/types/earn.types";
import type { EarnTableView } from "@bitwarden/web-vault/app/models/types/transaction.types";
import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { EarnLookup } from "@bitwarden/web-vault/app/services/earn/lookup.service";

/** Params we expect from ag-grid + your header params */
type Params = IHeaderParams & {
  colId: string;
  earnTableState?: string; // optional if you want to disable in non-draft
};

@Component({
  selector: "app-checkbox-header-renderer",
  templateUrl: "./header.renderer.html",
  host: { class: "tw-flex tw-w-full" },
})
export class CheckboxHeaderRenderer implements IHeaderAngularComp {
  private params!: Params;
  earnService: EarnService = inject(EarnService);
  earnLookup = inject(EarnLookup);
  headerName = "";
  colId!: keyof EarnTableView;
  disabled = false;
  isMasked = computed(() => {
    const lookupMask = this.earnLookup.lookupMask();
    const colId = this.params.column?.getColDef()?.field as ColumnKey;
    return lookupMask.columns.has(colId);
  });

  agInit(params: Params): void {
    this.params = params;
    this.headerName = params.displayName ?? params.column?.getColDef()?.headerName ?? "";

    this.colId = params.column?.getColId() as keyof EarnTableView;
  }

  refresh(params: Params): boolean {
    this.params = params;
    return true;
  }

  onToggle() {
    this.earnLookup.toggleColumn(this.colId);
  }
}
